export default __webpack_public_path__ + "static/pig04-28bbc47181e865d7791b7c8619c0712d.png";